import { render, staticRenderFns } from "./AppointmentDateRangeLabel.vue?vue&type=template&id=478c9c02&scoped=true&"
import script from "./AppointmentDateRangeLabel.vue?vue&type=script&lang=ts&"
export * from "./AppointmentDateRangeLabel.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentDateRangeLabel.vue?vue&type=style&index=0&id=478c9c02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478c9c02",
  null
  
)

export default component.exports